import React from 'react';
import { useTranslation } from 'react-i18next';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Body, Heading, Numeric } from '@swyftx/aviary/atoms/Typography';
import { ReviewItem } from '@swyftx/aviary/molecules/ReviewItem';
import { MarginOrderDirection } from '@swyftx/margin/build/types';

import { DATA_FIELDS, SIZE_LOTS, SYMBOL } from './ClosingPositionsContentSample.data';

type CloseType = 'market' | 'takeProfit' | 'stopLoss';

type Props = {
  direction: MarginOrderDirection;
  type: CloseType;
};

const ClosingPositionsContentSampleScenario: React.FC<Props> = ({ direction, type }) => {
  const { t } = useTranslation('margin');

  return (
    <FlexLayout direction='column' spacing={12}>
      <Heading size='h5'>{t('understandingOrderTypes.labels.scenario')}</Heading>
      <Body color='secondary'>
        {t(`understandingOrderTypes.close.${direction}.${type}.scenario`, {
          symbol: SYMBOL,
          type: t(`understandingOrderTypes.close.labels.closeType.${type}`).toLowerCase(),
          direction: t(`tradeSide.${direction}`).toLowerCase(),
          averageFillPriceCloseAbove: DATA_FIELDS[direction][type].averageFillPriceCloseAbove,
          averageFillPriceCloseBelow: DATA_FIELDS[direction][type].averageFillPriceCloseBelow,
        })}
      </Body>
      <FlexLayout direction='column' spacing={4}>
        <ReviewItem
          title={t('understandingOrderTypes.close.labels.size')}
          className='mt-24 w-full sm:max-w-[343px] md:w-3/4'
        >
          <Numeric weight='emphasis' color='primary'>
            {SIZE_LOTS}
          </Numeric>
        </ReviewItem>
        {DATA_FIELDS[direction][type].averageFillPrice && (
          <ReviewItem
            title={t('understandingOrderTypes.close.labels.averageFillPrice')}
            className='w-full sm:max-w-[343px] md:w-3/4'
          >
            <Numeric weight='emphasis' color='primary'>
              {DATA_FIELDS[direction][type].averageFillPrice}
            </Numeric>
          </ReviewItem>
        )}
        {DATA_FIELDS[direction][type].takeProfitPrice && (
          <ReviewItem
            title={t('understandingOrderTypes.close.labels.takeProfit')}
            className='w-full sm:max-w-[343px] md:w-3/4'
          >
            <Numeric weight='emphasis' color='primary'>
              {DATA_FIELDS[direction][type].takeProfitPrice}
            </Numeric>
          </ReviewItem>
        )}
        {DATA_FIELDS[direction][type].stopLossPrice && (
          <ReviewItem
            title={t('understandingOrderTypes.close.labels.stopLoss')}
            className='w-full sm:max-w-[343px] md:w-3/4'
          >
            <Numeric weight='emphasis' color='primary'>
              {DATA_FIELDS[direction][type].stopLossPrice}
            </Numeric>
          </ReviewItem>
        )}
      </FlexLayout>
    </FlexLayout>
  );
};

export { ClosingPositionsContentSampleScenario };
